var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wp",domProps:{"innerHTML":_vm._s(_vm.datas)}})
}
var staticRenderFns = []

export { render, staticRenderFns }